import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79497a11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-1" }
const _hoisted_3 = { class: "p-mx-1" }
const _hoisted_4 = { class: "p-mx-1" }
const _hoisted_5 = { class: "p-mx-1" }
const _hoisted_6 = { class: "p-mx-2 p-d-flex p-ai-center" }
const _hoisted_7 = { class: "p-mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_9 = { class: "confirmation-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem","color":"red"}
}, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "confirmation-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Are you sure to delete the product? ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" ?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_FileUploader = _resolveComponent("FileUploader")!
  const _component_ProductForm = _resolveComponent("ProductForm")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Toolbar, null, {
          start: _withCtx(() => [
            _createVNode(_component_Breadcrumb, {
              home: _ctx.home,
              model: _ctx.items,
              class: "p-menuitem-text"
            }, null, 8, ["home", "model"])
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (this.addUpdateProduct)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-upload",
                    label: "Upload Products",
                    class: "p-button-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openProductUploader()))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              (this.addUpdateProduct)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-download",
                    label: "Download Product CSV",
                    class: "p-button-warning",
                    onClick: _ctx.downloadCSV
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (this.addUpdateProduct)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-upload",
                    label: "Update Product CSV",
                    class: "p-button-primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openFileUploader()))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (this.addUpdateProduct)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-plus",
                    label: "Add Product",
                    class: "p-button-success",
                    onClick: _ctx.openDialog
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keyword) = $event)),
                modelModifiers: { trim: true },
                placeholder: "Product Name, Generic Name, Common Name, Reference, Barcode",
                style: {"width":"20rem"},
                class: "p-mr-2",
                onKeydown: _withKeys(_ctx.handleSearch, ["enter"])
              }, null, 8, ["modelValue", "onKeydown"]),
              _createVNode(_component_Button, {
                icon: "pi pi-search",
                class: "p-button-success p-ml-2",
                onClick: _ctx.loadSearchData,
                disabled: !_ctx.keyword || _ctx.keyword.trim() === ''
              }, null, 8, ["onClick", "disabled"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_DataTable, {
            first: _ctx.goToFirstLink,
            "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
            firstModifiers: { sync: true },
            value: _ctx.lists,
            dataKey: "id",
            ref: "dt",
            lazy: true,
            paginator: _ctx.checkPagination,
            rows: Number(_ctx.limit),
            totalRecords: _ctx.totalRecords,
            resizableColumns: true,
            columnResizeMode: "expand",
            responsiveLayout: "scroll",
            onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPage($event))),
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines",
            rowClass: _ctx.rowClass
          }, {
            empty: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "ID" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.id), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Product Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.product_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Generic Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.generic_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Common Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.common_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Reference(*)" }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_InputText, {
                    style: {"width":"80px"},
                    modelValue: slotProps.data.reference,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.reference) = $event),
                    disabled: _ctx.editingRow !== slotProps.data.id,
                    class: "p-p-1"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Min Stock" }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_InputText, {
                    modelValue: slotProps.data.min_stock,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.min_stock) = $event),
                    disabled: _ctx.editingRow !== slotProps.data.id,
                    style: {"width":"80px"},
                    class: "p-p-1"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Product Location" }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_InputText, {
                    style: {"width":"80px"},
                    modelValue: slotProps.data.product_location,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.product_location) = $event),
                    disabled: _ctx.editingRow !== slotProps.data.id,
                    class: "p-p-1"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  (_ctx.addUpdateProduct)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: 
                                    _ctx.editingRow === slotProps.data.id
                                        ? 'pi pi-check'
                                        : 'pi pi-pencil'
                                ,
                        class: _normalizeClass([
                                    _ctx.editingRow === slotProps.data.id
                                        ? 'p-button-rounded p-button-primary'
                                        : 'p-button-rounded p-button-success'
                                , "p-mr-2"]),
                        onClick: ($event: any) => (_ctx.toggleEdit(slotProps.data)),
                        disabled: 
                                    !_ctx.canEdit(slotProps.data) &&
                                    !_ctx.enableEditButton
                                
                      }, null, 8, ["icon", "class", "onClick", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Barcode" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.barcode), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Unit Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getUnitNameById(slotProps.data.unit_id)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Unit Value" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.unit_value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Prescription" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.prescription === 1 ? "Yes" : "No"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Insurance" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.insurance === 1 ? "Yes" : "No"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Expirable" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.expirable === 1 ? "Yes" : "No"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Product Type*" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getProductTypeById(slotProps.data.type_id)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Brand Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getBrandNameById(slotProps.data.brand_id)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Brand Sector" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getBrandSectorById(
                                    slotProps.data.brand_sector_id
                                )), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Category" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.getCategoryById(slotProps.data.category_id)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Side Effects" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.side_effects), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Description" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.description), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                exportable: false,
                header: "Action"
              }, {
                body: _withCtx((slotProps) => [
                  (this.deleteProduct)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "pi pi-trash",
                        class: "p-button-rounded p-button-danger",
                        onClick: ($event: any) => (_ctx.confirmDeleteItem(slotProps.data)),
                        disabled: !slotProps.data.created_by
                      }, null, 8, ["onClick", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["first", "value", "paginator", "rows", "totalRecords", "rowClass"]),
          _createVNode(_component_FileUploader, {
            uploaderDetail: {
                        status: _ctx.prodUploaderStatus,
                        dialogTitle: 'Upload Products:',
                        imageType: '.csv',
                    },
            onUpdateUploaderStatus: _ctx.updateProductUploader
          }, null, 8, ["uploaderDetail", "onUpdateUploaderStatus"]),
          _createVNode(_component_FileUploader, {
            uploaderDetail: {
                        status: _ctx.uploaderStatus,
                        dialogTitle: 'Upload Products Details CSV File:',
                        imageType: '.csv',
                    },
            onUpdateUploaderStatus: _ctx.updateUploaderStatus
          }, null, 8, ["uploaderDetail", "onUpdateUploaderStatus"]),
          _createVNode(_component_ProductForm, {
            productDialog: _ctx.productDialog,
            "onUpdate:productDialog": [
              _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productDialog) = $event)),
              _cache[6] || (_cache[6] = ($event: any) => (_ctx.productDialog = $event))
            ],
            dialogTitle: 'Add New Product',
            onSaveProduct: _ctx.handleProductSave,
            onCloseDialog: _ctx.closeDialog
          }, null, 8, ["productDialog", "onSaveProduct", "onCloseDialog"])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.errorDialog,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.errorDialog) = $event)),
      style: { width: '450px' },
      header: "Invalid Data"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "OK",
          icon: "pi pi-check",
          class: "p-button-success",
          onClick: _ctx.closeErrorDialog
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_ctx.errorMessages().length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages(), (message, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    style: {"font-size":"1rem"}
                  }, _toDisplayString(message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.deleteConfirmationDialog,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.deleteConfirmationDialog) = $event)),
      style: { width: '450px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-success",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteConfirmationDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          class: "p-button-danger",
          onClick: _ctx.handleClick
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", null, [
            _hoisted_14,
            _createElementVNode("b", null, _toDisplayString(_ctx.state.productName), 1),
            _hoisted_15
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}